import { Icon, Navigation } from "@shopify/polaris";
import { useLocation } from "react-router-dom";
import { CustomersMajor, DataVisualizationMajor, ChevronDownMinor } from "@shopify/polaris-icons";

// import { useGetUsersQuery } from '../redux/services/users'

const Sidebar = () => {
  const rLocation = useLocation();
  //const result =  useGetUsersQuery(undefined, { pollingInterval: 2000 });

  return (
    <Navigation location={rLocation.pathname}>
      <Navigation.Section
        fill={false}
        items={[
          {
            url: "/",
            label: 'Organizations',
            icon: CustomersMajor,
            selected: rLocation.pathname === '/',
            subNavigationItems: [
              {
                url: "/user",
                disabled: false,
                label: 'Users',
              },
            ],
          },
          {
            url: "/emissions",
            label: 'Master Data',
            icon: DataVisualizationMajor,
            selected: rLocation.pathname === '/businesses',
            badge: <Icon source={ChevronDownMinor} color='success' />,
            subNavigationItems: [
              {
                url: "/emissions",
                disabled: false,
                label: 'Emissions',
              },
              {
                url: "/sectors",
                disabled: false,
                label: 'Sectors',
              },
              {
                url: "/countries",
                disabled: false,
                label: 'Countries',
              },
              {
                url: "/assetclasses",
                disabled: false,
                label: 'Asset Classes',
              },
              {
                url: "/counterparties",
                disabled: false,
                label: 'Counter Parties',
              },
              {
                url: "/climaterisk",
                disabled: false,
                label: 'Climate Risk',
              },
              // {
              //   url: "/reports",
              //   disabled: false,
              //   label: 'Reports',
              // },
            ],
          },
        ]}
      />
    </Navigation>
  );
};

export default Sidebar;
